<app-card heading="Pagamento com PIX" class="block max-w-4xl mx-auto">
  <div class="flex flex-col gap-5 items-center lg:flex-row">
    <qrcode [qrdata]="code()!" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
    <div class="flex flex-col gap-5">
      <div class="space-y-2.5">
        <h2 class="text-sm font-medium text-gray-900 text-center lg:text-left">Aqui está o seu código de pagamento</h2>
        <p class="text-sm text-gray-700 text-center lg:text-left">
          Copie o código ou use a câmera para ler o QRCode ao lado e realize o pagamento no aplicativo do seu banco de
          preferência.
        </p>
      </div>

      <div class="space-y-2.5">
        <app-input #input [defaultValue]="code()" size="lg" inputClass="text-gray-600" [readOnly]="true" (focused)="onFocus()" />
        <button type="button" class="w-full kt-btn flex items-center" (click)="onCopy()">
          <span class="leading-tight font-medium">
            Copiar código PIX
          </span>
          <app-icon [icon]="copyIcon()" [size]="12" />
        </button>
      </div>

      <p class="text-center text-sm">
        O seu código expira em
        <b>
          {{ days() | number:'2.0' }}d
          {{ hours() | number:'2.0' }}h
          {{ minutes() | number:'2.0' }}m
          {{ seconds() | number:'2.0' }}s
        </b>
      </p>
    </div>
  </div>
</app-card>
